import styled from 'styled-components';
import { LegacyButtonBase } from '../LegacyButtonBase';

export const StyledLegacySecondaryButton = styled(LegacyButtonBase)`
  font-family: ${(props): string => props.theme.fonts.buttonM};
  font-size: ${(props): string => props.theme.fontSizes.buttonM};
  line-height: ${(props): string => props.theme.lineHeights.buttonM};
  font-weight: ${(props): number => props.theme.fontWeights.buttonM};
  background-color: ${(props): string => props.theme.colors.white};
  color: ${(props): string => props.theme.colors.black};
  border: 2px solid ${(props): string => props.theme.colors.black};
  border-radius: 0;

  // TODO: should use design token, add more specificity to override
  &.ant-btn.legacy-button-base {
    :hover,
    :focus,
    :active {
      border-color: ${(props): string => props.theme.colors.black};
      background-color: ${(props): string => props.theme.colors.white};
      color: ${(props): string => props.theme.colors.black};
    }

    :hover {
      background-color: ${(props): string => props.theme.colors.brightGrey};
    }

    :focus {
      border: 2px solid ${(props): string => props.theme.colors.focusBorder};
    }

    :active {
      background-color: ${(props): string => props.theme.colors.black};
      color: ${(props): string => props.theme.colors.white};
    }

    :disabled,
    :disabled:hover {
      border-color: ${(props): string => props.theme.colors.brightGrey};
      background-color: ${(props): string => props.theme.colors.white};
      color: ${(props): string => props.theme.colors.brightGrey};
    }

    &.legacy-button__size-s {
      height: auto;
      font-size: ${(props): string => props.theme.fontSizes.p1};
      line-height: ${(props): string => props.theme.lineHeights.p1};
      padding: 6px 12px 5px;
    }

    &.legacy-button__size-m {
      width: fit-content;
      height: 44px;
      font-size: ${(props): string => props.theme.fontSizes.buttonM};
      line-height: ${(props): string => props.theme.lineHeights.buttonM};
      padding: 12px 16px;
    }
  }
`;
